import { Card } from "antd";
import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import dayjs from "dayjs";

import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";
import {
	loadSingleShift,
} from "../../redux/rtk/features/shift/shiftSlice";
import ShiftEditPopup from "../UI/PopUp/ShiftEditPopup";
import ShifDelete from "./shiftDelete";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const DetailShift = () => {
	const { id } = useParams();
	const dispatch = useDispatch();

	const shift = useSelector((state) => state.shift.shift);

	useEffect(() => {
		if (id) {
			dispatch(loadSingleShift(id));
		}
	}, [id, dispatch]);

	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace />;
	}

	return (
		<div>
			<PageTitle title='Back' />

			<UserPrivateComponent permission={"readSingle-shift"}>
				<Card className='mt-5'>
					{shift ? (
						<Fragment>
							{/* HEADER */}
							<div className='flex justify-between mb-4'>
								<h3 className='text-xl'>
									ID: {shift._id} | {shift.name}
								</h3>

								<div className='flex gap-2'>
									<UserPrivateComponent permission={"update-shift"}>
										<ShiftEditPopup data={shift} />
									</UserPrivateComponent>

									<UserPrivateComponent permission={"delete-shift"}>
										<ShifDelete id={shift._id} />
									</UserPrivateComponent>
								</div>
							</div>

							{/* ✅ SHIFT DETAILS (FIXED) */}
							<div className='mt-4'>
								<p>
									<b>Name:</b> {shift.name}
								</p>
								<p>
									<b>Start Time:</b>{" "}
									{shift.startTime
										? dayjs(shift.startTime).format("hh:mm A")
										: "N/A"}
								</p>
								<p>
									<b>End Time:</b>{" "}
									{shift.endTime
										? dayjs(shift.endTime).format("hh:mm A")
										: "N/A"}
								</p>
							</div>
						</Fragment>
					) : (
						<Loader />
					)}
				</Card>
			</UserPrivateComponent>
		</div>
	);
};

export default DetailShift;